//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { COLUMN_PERMISSION } from '@/utils/constant';

export default {
  name: 'WorkflowDetailConfigPermission',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      COLUMN_PERMISSION,
    };
  },
  computed: {
    propertyList() {
      const list = [];
      Object.keys(this.value).forEach((key) => {
        list.push({
          name: key,
          value: this.value[key],
        });
      });
      return list;
    },
  },
  methods: {
    updateValue(key) {
      this.$emit('update', {
        ...this.value,
        [key]:
          this.value[key] === COLUMN_PERMISSION.readonly
            ? COLUMN_PERMISSION.editable
            : COLUMN_PERMISSION.readonly,
      });
    },
  },
};
